export default "__VITE_ASSET__36445a4f__"